export const llmFeedbackSugestion = async (
  question,
  answer,
  tag_content,
  callback,
  setLoading,
  tag_type,
  tag_id
) => {
  const lang = localStorage.getItem("user-lang") || "pt-BR";
  const response = await fetch("api/generate-feedback", {
    method: "post",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      Authorization: `Token ${window.localStorage.getItem("tokenAuth")}`,
    },
    body: JSON.stringify({
      question,
      answer,
      tag_content,
      tag_type,
      lang,
      tag_id,
    }),
  });

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  const loopRunner = true;
  if (reader) {
    while (loopRunner) {
      // Here we start reading the stream, until its done.
      const { value, done } = await reader.read();

      const decodedChunk = decoder.decode(value, { stream: true });
      callback((answer) => answer + decodedChunk);
      if (done) {
        setLoading(false);
        break;
      }
    }
  }
  setLoading(false);
};

export const llmCorrectionSuggestion = async (questionId, responseId) => {
  const response = await fetch("api-ia/avaliar_resposta", {
    method: "post",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      "x-api-key":
        "efcb6c246c2f083ab9d8ed8dec6c2333b4017069dc6d77cb54a155dc3b37cc41",
    },
    body: JSON.stringify({
      question_id: questionId,
      response_id: responseId,
    }),
  });

  const responseJson = await response.json();

  return responseJson;
};

export const llmCorrectionAll = async (formId, correctFinishedQuestions) => {
  const response = await fetch(`api-ia/batch-correct/${formId}`, {
    method: "post",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      "x-api-key":
        "efcb6c246c2f083ab9d8ed8dec6c2333b4017069dc6d77cb54a155dc3b37cc41",
      Authorization: `Bearer ${window.localStorage.getItem("tokenAuth")}`,
    },
    body: JSON.stringify({ force: correctFinishedQuestions }),
  });
  const responseJson = await response.json();

  return responseJson;
};

export const CheckllmCorrectionAll = async (formId) => {
  const response = await fetch(
    `https://tutor-ia.com/api-ia/progress/${formId}`,
    {
      method: "get",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "x-api-key":
          "efcb6c246c2f083ab9d8ed8dec6c2333b4017069dc6d77cb54a155dc3b37cc41",
        Authorization: `Bearer ${window.localStorage.getItem("tokenAuth")}`,
      },
    }
  );
  const responseJson = await response.json();

  return responseJson;
};
